var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F4AE95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89144 5.03885L5.46356 12.3553H11.1544C11.3192 12.3553 11.4682 12.4565 11.5329 12.6112L11.5391 12.6253C11.5603 12.6757 11.5697 12.7302 11.5667 12.7848C11.5637 12.8394 11.5483 12.8925 11.5217 12.9403C11.4752 13.0242 11.4072 13.0943 11.3246 13.1432C11.2421 13.1922 11.148 13.2182 11.052 13.2187H5.004C4.9104 13.2186 4.81904 13.1901 4.74188 13.1372L4.71037 13.1158C4.61515 13.0493 4.54653 12.9513 4.51667 12.8391C4.48681 12.7268 4.49765 12.6077 4.54725 12.5027L8.59163 3.98135C8.63381 3.89248 8.694 3.81373 8.76769 3.75073C8.83722 3.69076 8.92572 3.6573 9.01754 3.65627C9.10935 3.65525 9.19858 3.68671 9.26944 3.7451C9.30162 3.77131 9.32756 3.80436 9.34538 3.84185L13.4477 12.4211C13.5039 12.5375 13.5152 12.6708 13.4803 12.7957C13.4622 12.8637 13.4222 12.9238 13.3664 12.9668C13.3107 13.0098 13.2424 13.0333 13.1721 13.0337H13.1248C13.0304 13.0331 12.9381 13.0054 12.859 12.954C12.7798 12.9025 12.7171 12.8295 12.6782 12.7434L9.14006 5.03998C9.12941 5.01596 9.11208 4.99551 9.09014 4.98105C9.06821 4.9666 9.04258 4.95874 9.01631 4.95841C8.98997 4.95842 8.9642 4.96602 8.94205 4.98028C8.91991 4.99454 8.90234 5.01487 8.89144 5.03885Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlt);
export default __webpack_public_path__ + "static/media/dlt.45fa646d6cf59671751bfe43e0a782b4.svg";
export { ForwardRef as ReactComponent };